import * as React from 'react';
import { Component, inject, deps, observer } from '../lib/component';
import {PageGenericPrismic} from '../components/page-generic-prismic';

export interface TermsAndConditionsPageProps {}

@inject(deps) @observer
export class TermsAndConditionsPage extends Component<TermsAndConditionsPageProps> {
  render() {
    return (
      <PageGenericPrismic
        model={this.props.model.page.termsAndConditions}
      />
    )
  }
}